import { useState } from "react";
import StepWelcome from "./steps/StepWelcome";
import StepCategory from "./steps/StepCategory";
import StepSubcategory from "./steps/StepSubcategory";
import StepVisualEnhancements from "./steps/StepVisualEnhancements";
import StepReportStyle from "./steps/StepReportStyle";
import StepBranding from "./steps/StepBranding";
import StepDesiredOutcome from "./steps/StepDesiredOutcome";
import StepPaymentDelivery from "./steps/StepPaymentDelivery";
import StepResult from "./steps/StepResult";

const steps = [
  "Welcome",
  "Category",
  "Subcategory",
  "VisualEnhancements",
  "ReportStyle",
  "Branding",
  "DesiredOutcome",
  "PaymentDelivery",
  "Result"
];

export default function ReportFunnel() {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({});

  const nextStep = (data = {}) => {
    setFormData(prev => ({ ...prev, ...data }));
    setStep(s => Math.min(s + 1, steps.length - 1));
  };

  const prevStep = () => setStep(s => Math.max(s - 1, 0));

  const stepComponents = [
    <StepWelcome onNext={nextStep} formData={formData} />,
    <StepCategory onNext={nextStep} onBack={prevStep} formData={formData} />,
    <StepSubcategory onNext={nextStep} onBack={prevStep} formData={formData} />,
    <StepVisualEnhancements onNext={nextStep} onBack={prevStep} formData={formData} />,
    <StepReportStyle onNext={nextStep} onBack={prevStep} formData={formData} />,
    <StepBranding onNext={nextStep} onBack={prevStep} formData={formData} />,
    <StepDesiredOutcome onNext={nextStep} onBack={prevStep} formData={formData} />,
    <StepPaymentDelivery onNext={nextStep} onBack={prevStep} formData={formData} />,
    <StepResult formData={formData} />,
  ];

  return (
    <div className="max-w-xl mx-auto p-4">
      <ProgressBar step={step} total={steps.length} stepNames={steps} />
      <div className="mt-6">{stepComponents[step]}</div>
    </div>
  );
}

function ProgressBar({ step, total, stepNames }) {
  return (
    <div className="w-full bg-gray-200 rounded-full h-2 mb-6 relative">
      <div
        className="bg-blue-600 h-2 rounded-full transition-all"
        style={{ width: `${((step + 1) / total) * 100}%` }}
      />
      <div className="text-xs text-center mt-2">
        Step {step + 1} of {total}: {stepNames[step]}
      </div>
    </div>
  );
}
